import {FileValue} from 'common/models/survey';

import uploadFile from './uploadFile';

interface DataUrlValue {
    format: 'dataUrl';
    dataUrl: string;
    name?: string;
}

export const hasDataUrl = (value: unknown) => {
    return (
        value &&
        typeof value === 'object' &&
        !Array.isArray(value) &&
        'format' in value &&
        value.format === 'dataUrl' &&
        'dataUrl' in value &&
        typeof value.dataUrl === 'string' &&
        value.dataUrl
    );
};

export const processDataUrl = (surveyId: string, value: DataUrlValue) => {
    const file = createFile(value.dataUrl, value.name);

    if (!file) {
        return null;
    }
    return uploadFile(surveyId, file).then((response): FileValue => {
        return {
            ...response,
            loading: false,
        };
    });
};

export const createFile = (dataUrl: string, name?: string) => {
    // https://stackoverflow.com/a/7261048/2783730
    const byteString = atob(dataUrl.split(',')[1]);
    const mimeString = dataUrl.split(',')[0].split(':')[1].split(';')[0];
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const intArray = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
        intArray[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([arrayBuffer], {type: mimeString});

    const mimeMap: Record<string, string> = {
        'image/png': 'png',
        'image/jpeg': 'jpg',
        'application/json': 'json',
    };

    const blobType = blob.type;
    const extension = mimeMap[blobType];

    if (!mimeMap[blob.type]) {
        return null;
    }

    if (!name) {
        const iso = new Date()
            .toISOString()
            .replace('T', '--')
            .replace('Z', '')
            .replace(/[:.]/g, '-');

        name = `${iso}.${extension}`;
    }
    return new File([blob], name);
};
